import React, { useState } from 'react';
import { db } from '../firebaseConfig';
import { doc, getDoc, setDoc } from 'firebase/firestore';
import MessageModal from '../components/MessageModal';

const AddAnalysisPage = ({ user, setView }) => {
    const [step, setStep] = useState(1);
    const [childId, setChildId] = useState('');
    const [productDetails, setProductDetails] = useState(null);
    const [compData, setCompData] = useState({
        comp1_company: '', comp1_url: '', comp1_price: '',
        comp2_company: '', comp2_url: '', comp2_price: ''
    });
    const [error, setError] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [modalState, setModalState] = useState({ message: '' });

    const handleFindProduct = async () => {
        if (!childId.trim()) {
            setError("Please enter a Child Product ID.");
            return;
        }
        setIsSubmitting(true);
        setError('');
        const productRef = doc(db, 'inventoryItems', childId.trim());
        const productSnap = await getDoc(productRef);

        if (!productSnap.exists()) {
            setError(`Product ID "${childId.trim()}" not found.`);
            setIsSubmitting(false);
        } else {
            setProductDetails(productSnap.data());
            setStep(2);
            setIsSubmitting(false);
        }
    };

    const handleSave = async () => {
        const isConfirmed = window.confirm("Are you sure you want to save this analysis?");
        if (!isConfirmed) return;

        setIsSubmitting(true);
        const dataToSave = {
            childId: childId.trim(),
            userId: user.uid,
            comp1_company: compData.comp1_company || '',
            comp1_url: compData.comp1_url || '',
            comp1_price: parseFloat(compData.comp1_price) || 0,
            comp2_company: compData.comp2_company || '',
            comp2_url: compData.comp2_url || '',
            comp2_price: parseFloat(compData.comp2_price) || 0,
            lastUpdatedAt: new Date(),
        };

        try {
            await setDoc(doc(db, "competitorAnalysis", childId.trim()), dataToSave);
            setModalState({ message: "Analysis saved successfully!", onConfirm: () => setView('competitors') });
        } catch (err) {
            console.error("Error saving analysis:", err);
            setModalState({ message: `Error: ${err.message}`, onConfirm: () => setModalState({message: ''}) });
        } finally {
            setIsSubmitting(false);
        }
    };
    
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setCompData(prev => ({ ...prev, [name]: value }));
    };

    return (
        <div>
            <MessageModal message={modalState.message} onConfirm={modalState.onConfirm} />
            <div className="page-header">
                <h2>Add New Competitor Analysis</h2>
                <button className="cancel-button" onClick={() => setView('competitors')}>Back to List</button>
            </div>

            {step === 1 && (
                <div className="form-section competitor-search-container">
                    <h3>Step 1: Find Product</h3>
                    <p>Enter the Child Product ID to begin the analysis.</p>
                    <div className="competitor-search-bar">
                        <div className="form-field">
                            <label>Child Product ID*</label>
                            <input type="text" value={childId} onChange={(e) => setChildId(e.target.value.toUpperCase())} placeholder="e.g., TTJ1001" autoFocus/>
                        </div>
                        <div className="form-actions" style={{alignSelf: 'flex-end'}}>
                            <button className="cancel-button" onClick={() => setView('competitors')} disabled={isSubmitting}>Cancel</button>
                            <button className="submit-button" onClick={handleFindProduct} disabled={isSubmitting}>
                                {isSubmitting ? 'Searching...' : 'Find Product'}
                            </button>
                        </div>
                    </div>
                    {error && <p className="error-message">{error}</p>}
                </div>
            )}

            {step === 2 && (
                <div>
                    <div className="analyzed-product-card--full">
                        <img src={productDetails.imageUrl} alt={productDetails.itemName} className="analyzed-product-image" />
                        <div className="analyzed-product-details">
                            <div className="spec-field"><strong>ID:</strong><div>{productDetails.childId}</div></div>
                            <div className="spec-field"><strong>Name:</strong><div>{productDetails.itemName}</div></div>
                            <div className="spec-field"><strong>Your Price:</strong><div style={{color: 'var(--brand-success)', fontWeight: 'bold'}}>RM {Number(productDetails.sellingPriceMYR).toFixed(2)}</div></div>
                        </div>
                    </div>
                    <div className="form-section">
                        <h4>Competitor 1</h4>
                        <div className="form-grid">
                            <div className="form-field"><label>Company / Platform</label><input type="text" name="comp1_company" value={compData.comp1_company} onChange={handleInputChange} /></div>
                            <div className="form-field"><label>Price (RM)</label><input type="number" step="0.01" name="comp1_price" value={compData.comp1_price} onChange={handleInputChange} /></div>
                            <div className="form-field full-span"><label>Product URL</label><input type="url" name="comp1_url" value={compData.comp1_url} onChange={handleInputChange} /></div>
                        </div>
                    </div>
                    <div className="form-section">
                        <h4>Competitor 2</h4>
                        <div className="form-grid">
                            <div className="form-field"><label>Company / Platform</label><input type="text" name="comp2_company" value={compData.comp2_company} onChange={handleInputChange} /></div>
                            <div className="form-field"><label>Price (RM)</label><input type="number" step="0.01" name="comp2_price" value={compData.comp2_price} onChange={handleInputChange} /></div>
                            <div className="form-field full-span"><label>Product URL</label><input type="url" name="comp2_url" value={compData.comp2_url} onChange={handleInputChange} /></div>
                        </div>
                    </div>
                    <div className="form-actions" style={{ justifyContent: 'flex-end', marginTop: '1rem' }}>
                        <button type="button" className="cancel-button" onClick={() => setView('competitors')} disabled={isSubmitting}>Cancel</button>
                        <button type="button" className="submit-button" onClick={handleSave} disabled={isSubmitting}>
                            {isSubmitting ? 'Saving...' : 'Save Analysis'}
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default AddAnalysisPage;